module.exports = __webpack_public_path__ + "static/media/06_tn.d2d59876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/06_tn.jpg
// module id = 495
// module chunks = 0